/* eslint-disable no-shadow */
import VueScrollTo from 'vue-scrollto';
import router from '../router';
// import i18n from '../i18n';

const state = {
  mainMenu: [
    /* {
      text: 'mainNavBar.catalog',
      click: () => {
        router.push('/');
      },
    }, */
    {
      text: 'mainNavBar.howItWorks',
      externalLink: false,
      route: '/hogyan-mukodik',
      click: () => {
        router.push('/hogyan-mukodik');
      },
    },
    {
      text: 'mainNavBar.aboutUs',
      externalLink: false,
      route: '/rolunk',
      click: () => {
        router.push('/rolunk');
      },
    },
    {
      text: 'mainNavBar.faq',
      externalLink: true,
      route1: 'https://www.samsung.com/hu/offer/mobile-trade-in/',
      click: () => {
        window.open('https://www.samsung.com/hu/offer/mobile-trade-in/', '_blank');
      },
    },
    {
      text: 'mainNavBar.promoPlaces',
      externalLink: true,
      route1: 'https://www.samsung.com/hu/offer/mobile-trade-in/',
      route2: 'https://www.samsung.com/hu/article/galaxy-a52s-tc/',
      click: () => {
        window.open('https://www.samsung.com/hu/offer/mobile-trade-in/', '_blank');
      },
    },
  ],
  scrollOptions: {
    duration: 900,
    offset: 60,
  },
};

const getters = {
  //
};

const actions = {
  //
};
const mutations = {
  //
};
export default {
  state,
  actions,
  mutations,
  getters,
};
